import { Component, OnInit } from '@angular/core';
import { AuthHeaderComponent } from '../auth-header/auth-header.component';
import { LoginComponent } from '../../auth/login/login.component';
import { FooterComponent } from '../footer/footer.component';
import { CookieConsentComponent } from '../cookie-consent/cookie-consent.component';
import { ChatComponent } from "../../shared/chat/chat.component";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    AuthHeaderComponent,
    LoginComponent,
    FooterComponent,
    CookieConsentComponent,
    ChatComponent,
    CommonModule
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  ngOnInit(): void {
    this.handlePopupClosed();
  }
  isOpen = false;
  cookiesClosed = false;
  isCookieDismissed = false;
  isCookieAccepted = false;

  setIsOpen() {
    this.isOpen = !this.isOpen;
  }

  handlePopupClosed(): void {
    this.isCookieAccepted = this.checkCookieConsent();
    this.isCookieDismissed = this.checkCookieDismissal();

    if (this.isCookieAccepted || this.isCookieDismissed) {
      this.cookiesClosed = true;
    }    
  }

  checkCookieConsent(): boolean {
    return localStorage.getItem('cookie-consent') === 'accepted';
  }

  checkCookieDismissal(): boolean {
    return sessionStorage.getItem('cookie-dismissed') === 'true';
  }
  
}
